import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onMoreProductFiltersSelected = ({
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
}: {
	actionSubjectId: string;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'track',
	action: 'selected',
	actionSubject: 'moreProductFilters',
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
});
